import { combineReducers } from 'redux';
import app from './app';
import search from './search';
import searchAll from './search-all';
import overlay from './overlay';
import menu from './menu';
import details from './details';
import profile from './profile';
import promocode from './promocode';
import loader from './loader';
import channels from './channels';
import modal from './modal';
import toast from './toast';
import continueWatching from './continue-watching';
import terms from './terms';
import parental from './parental-lock';
import watchlist from './watchlist';
import purchases from './purchases';
import player from './player';
import autostartTV from './autostart-tv';
import EPGWidget from './epg-widget';

const createRootReducer = () =>
  combineReducers({
    app,
    search,
    searchAll,
    overlay,
    menu,
    details,
    profile,
    loader,
    modal,
    toast,
    channels,
    continueWatching,
    terms,
    parental,
    watchlist,
    purchases,
    player,
    promocode,
    autostartTV,
    EPGWidget,
  });

export default createRootReducer;
